<template>
  <div>
    <div
    class="rich-articel"
      v-html="
        isArticel.type == 'info' ? isArticel.content : isArticel.info.content
      "
    ></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "articel",
  computed: mapGetters(["isArticel"]),
};
</script>

<style scoped lang='less'>
</style>


// WEBPACK FOOTER //
// src/components/common/articel.vue